$(document).ready(function () {
   $(document).on('click', '.modal-closed', function () {
     hidePopupLoginModal();
     setCookie("signedUp", "true", 30);
  });

  function displayPopupLoginModal() {
    $("#login-pop-ups").css("display", "block");
    $("body").addClass("popup-model-opened");
  }

  // Function to hide the popup modal
  function hidePopupLoginModal() {
    $("#login-pop-ups").css("display", "none");
    $("body").removeClass("popup-model-opened");
  }

  
  $(window).on("click", function (e) {
    if (e.target.id == "login-pop-ups") {
      hidePopupLoginModal();
       setCookie("signedUp", "true", 30);
    }
    if (e.target.id == "login-pop-ups") {
      modal("#login-pop-ups", false);
    }
  });
     var signedUp = getCookie("signedUp");
  if (!signedUp) {
    setTimeout(function () {
                displayPopupLoginModal();
        }, 3000);
   }

   function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  // Function to get a cookie
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
});
